// src/index.ts
import { Script } from "@fuel-ts/script";

// src/cli/utils/createConfig.ts
function createConfig(config) {
  return config;
}

// src/cli/types.ts
var Commands = /* @__PURE__ */ ((Commands2) => {
  Commands2["build"] = "build";
  Commands2["deploy"] = "deploy";
  Commands2["dev"] = "dev";
  Commands2["init"] = "init";
  Commands2["versions"] = "versions";
  Commands2["node"] = "node";
  return Commands2;
})(Commands || {});

// src/index.ts
export * from "@fuel-ts/abi-coder";
export * from "@fuel-ts/address";
export * from "@fuel-ts/address/configs";
export * from "@fuel-ts/contract";
export * from "@fuel-ts/crypto";
export * from "@fuel-ts/errors";
export * from "@fuel-ts/hasher";
export * from "@fuel-ts/math";
export * from "@fuel-ts/math/configs";
export * from "@fuel-ts/program";
export * from "@fuel-ts/transactions";
export * from "@fuel-ts/utils";
export * from "@fuel-ts/account";
export * from "@fuel-ts/transactions/configs";
export * from "@fuel-ts/account/configs";
export * from "@fuel-ts/recipes";
export {
  Commands,
  Script,
  createConfig
};
//# sourceMappingURL=index.mjs.map